// Shared styles for the search bar + filter button layout.
import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

export const useSearchStyles = createStyles({
  filtersContainer: { display: "flex", flexDirection: "column", gap: tokens.spacing[4] },
  search: { display: "flex", flexDirection: "row", alignItems: "center", gap: tokens.spacing[2] },
  searchInput: {
    width: 400,
  },
  searchClearButton: {
    textDecoration: "none",
    padding: 0,
    border: "none",
  },
});
